import { Field, InputType } from 'type-graphql'
import type { MetadataType } from '../../base'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class CreateChargeArgs {
  @Field(() => String)
  amount: number

  @Field(() => String)
  source: string

  @Field(() => String)
  customer: string

  @Field(() => String)
  description: string

  @Field(() => GraphQLJSON)
  metadata: MetadataType

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}
